import { createSlatePlugin } from "platejs";
import { toNodeProps } from "./withNodeProps";

export const DivPlugin = createSlatePlugin({
  key: "div",
  node: {
    isElement: true,
    isContainer: true,
  },
  parsers: {
    html: {
      deserializer: {
        rules: [
          {
            validNodeName: "DIV",
          },
        ],
        toNodeProps: toNodeProps,
      },
    },
  },
});
